<template>
    <div class="join">
        <div class="list">
            <div class="title">联盟信息</div>
            <div class="box">
                <div class="leabl">联盟类型</div>
                <div class="checks">
                    <div :class="['check',type == item.id?'active':'']" v-for="item in typelist" :key="item.id" @click="type = item.id">
                        <img :src="item.imgurl" alt="">
                        <div>{{item.name}}</div>
                    </div>
                </div>
            </div>
            <van-field v-if="type == 1" readonly clickable v-model="typename" label="单项运动" @click="showPicker = true" placeholder="请选择所属的单项运动" />
            <template v-if="type == 2">
                <div class="box">
                    <div class="leabl">区域类型</div>
                    <div class="checks">
                        <div :class="['check2',areatype == item.id?'active2':'']" v-for="item in arealist" :key="item.id" @click="check(item)">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <van-field readonly clickable v-model="typename" label="类型选择" @click="showPicker2 = true" placeholder="请选择" />
            </template>
        </div>
        <div class="list pdd">
            <div class="title">社区体育健身团队信息表</div>
            <van-field v-model="name" label="团队名称" placeholder="请输入团队名称" />
            <van-field v-model="project" label="运动项目" @click="showPicker = true" placeholder="请选择运动项目" />
            <van-field v-model="num" label="团队人数" placeholder="请输入团队人数" />
            <van-field v-model="connenter_name" label="召集人" placeholder="请输入召集人" />
            <van-field v-model="connenter_phone" label="联系电话" placeholder="请输入联系电话" />
            <van-field v-model="address" label="活动场地" placeholder="请输入活动场地" />
            <van-field v-model="weeks" label="每周活动频率" placeholder="请输入每周活动频率(次)" />
        </div>
        <div class="footer">
            <div class="btn" @click="submit">
                提     交
            </div>
        </div>
        <van-popup v-model="showPicker" round position="bottom">
            <van-picker
                show-toolbar
                :columns="columns"
                @cancel="showPicker = false"
                @confirm="onConfirm"
            />
        </van-popup>
        <van-popup v-model="showPicker2" round position="bottom">
            <!-- <div  v-if="areatype>1" class="tips">如果是输入的类型，输入完成点击左侧取消按钮，优先从下来列表从选择</div>
            <van-field v-if="areatype>1" v-model="typename" label="类型选择" placeholder="请输入类型（无该选项时）" /> -->
            <van-picker
                show-toolbar
                :columns="columns2"
                @cancel="showPicker2 = false"
                @confirm="onConfirm2"
            />
        </van-popup>
    </div>
</template>

<script>
import { Cell, CellGroup,Field } from 'vant';

export default {
    components: {
       vanCell: Cell, vanCellGroup:CellGroup,vanField:Field
    },
    data() {
        return {
            typelist: [
                {
                    id: 1,
                    name: '加入单项联盟',
                    imgurl: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230822/1692697055/220961.png'
                },{
                    id: 2,
                    name: '加入区域联盟',
                    imgurl: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20230822/1692697055/895061.png'
                }
            ],
            arealist: [
                {
                    id: 1,
                    name: '街道社区'
                },{
                    id: 2,
                    name: '商务楼宇'
                },{
                    id: 3,
                    name: '企业单位'
                },{
                    id: 4,
                    name: '校园'
                }
            ],
            type: 1,
            columns: [],
            showPicker: false,
            showPicker2: false,
            typename: '',
            name: '',
            areatype: 0,
            project: '',
            num: '',
            connenter_name: '',
            connenter_phone: '',
            address: '',
            weeks: '',
            columns2: []
        }
    },
    mounted() {
        this.getlist()
    },
    methods: {
        check(item) {
            this.areatype = item.id
            this.$api.system.area({type:item.id}).then(res=>{
                this.columns2 = []
                this.typename = '';
                res.data.forEach(ele => {
                    this.columns2.push(ele.name)
                });
            })
        },
        onConfirm(value) {
            if(this.type==1) {
                this.typename = value;
            }           
            this.project = value;
            this.showPicker = false;
        },
        onConfirm2(value) {
            this.typename = value;
            this.showPicker2 = false;
        },
        getlist() {
            this.$api.system.plist().then(res=>{
                this.columns = []
                res.data.forEach(ele => {
                    this.columns.push(ele.name)
                });
            })
        },
        submit() {
            if(this.typename == '' || this.name == '' || this.project == '' || this.num == '' || this.connenter_name == '' || this.connenter_phone == '' || this.address == '' || this.weeks == '') {
                this.$dialog.alert({
                    title: '提示',
                    message: '信息未填完',
                })
                return
            }
            let query = {
                type: this.type,
                typename: this.typename,
                name: this.name,
                areatype: this.type == 2? this.areatype:0,
                project: this.project,
                num: this.num,
                connenter_name: this.connenter_name,
                connenter_phone: this.connenter_phone,
                address: this.address,
                weeks: this.weeks
            }
            this.$api.system.join(query).then(res=>{
                if (res.code == 200) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '创建成功',
                    })
                    this.$router.push({name:'sports'})
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.join{
    background: #F9F9F9;
    box-sizing: border-box;
    padding: .3rem;
    .list{
        background: #ffffff;
        border-radius: .08rem;
        padding-bottom: .1rem;
        margin-bottom: .2rem;
        .title{
            color: #333;
            font-size: .3rem;
            border-bottom: .01rem solid rgba(238,238,238,1);
            padding: .3rem;
        }
        .box{
            padding: .3rem;
            .leabl{
                font-size: .28rem;
                color: #7C7F8E;
                padding-bottom: .3rem;
            }
            .checks{
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;
                .check{
                    width: 3.1rem;
                    height: 1.98rem;
                    border-radius: .1rem;
                    background: #f5f5f5;
                    color: rgba(0,0,0,.65);
                    font-size: .24rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 1.1rem;
                        height: 1.1rem;
                    }
                }
                .active{
                    color: #025DF4;
                    background: #E6EFFE;
                }
                .check2{
                    border: .015rem solid rgba(238,238,238,1);
                    box-sizing: border-box;
                    padding: .16rem .28rem;
                    font-size: .28rem;
                    color: #7C7F8E;
                    margin-bottom: .28rem;
                    border-radius: .1rem;
                }
                .active2{
                    color: #025DF4;
                    background: #E6EFFE;
                    border: .015rem solid #025DF4;
                }
            }
        }
            
    }
    .pdd{
        margin-bottom: 2rem;
    }
    .footer{
        .btn{
            width: 100%;
            height: .9rem;
            color: #ffffff;
            line-height: .9rem;
            text-align: center;
            background: #025DF4;
            border-radius: .12rem;
        }
    }
    .tips{
        font-size: .28rem;
        color: #025DF4;
        padding: .2rem .3rem 0;
    }
}
</style>